/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SupplementalCoalitionUser
 */
export interface SupplementalCoalitionUser {
    /**
     * 
     * @type {string}
     * @memberof SupplementalCoalitionUser
     */
    email: string;
}

/**
 * Check if a given object implements the SupplementalCoalitionUser interface.
 */
export function instanceOfSupplementalCoalitionUser(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "email" in value;

    return isInstance;
}

export function SupplementalCoalitionUserFromJSON(json: any): SupplementalCoalitionUser {
    return SupplementalCoalitionUserFromJSONTyped(json, false);
}

export function SupplementalCoalitionUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupplementalCoalitionUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
    };
}

export function SupplementalCoalitionUserToJSON(value?: SupplementalCoalitionUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
    };
}

